<template>
  <div>
    <b-modal
      v-model="isNewsletterSubscriberModal"
      content-class="airspirit-modal"
      hide-footer
      header-class="airspirit-modal-header"
      body-class="newsletter-subscriber-modal-body"
      modal-class="newsletter-subscriber-modal"
      size="md"
    >
      <template #modal-header>
        <div class="newsletter-subscriber-modal-header">
          <div
            @click="closeModal"
            class="airspirit-modal-header--close-icon newsletter-subscriber-modal-header--close-icon"
          >
            <img
              :src="require('@/assets/images/pictos/croix.svg')"
            />
          </div>
          <div
            class="airspirit-modal-header--title newsletter-subscriber-modal-header--title"
          >
            {{ $t('newsletter_subscriber_modal.title') }}
          </div>
        </div>
      </template>

      <div class="mt-4" v-html="$t('newsletter_subscriber_modal.intro_text')" />


      <div class="mt-4">
        <strong>{{ $t('newsletter_subscriber_modal.tagline') }}</strong>
      </div>

      <input
        class="registration-input newsletter-subscriber-modal-input mt-4"
        type="text"
        maxlength="255"
        :placeholder="$t('newsletter_subscriber_modal.email_placeholder')"
        v-model="email"
        :state="$v.email.$dirty ? !$v.email.$error : null"
      >

      <div class="text-danger"
        v-if="errorSaved">
        {{ $t('newsletter_subscriber_modal.already_registered_error') }}
      </div>
      
      <button
        class="newsletter-subscriber-modal-button mt-4"
        :disabled="$v.$invalid"
        @click="signUpNewsletter"
      >
        {{ $t('newsletter_subscriber_modal.sign_up_button') }}
      </button>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import { APINewsletterSubscriber } from '@/api/APINewsletterSubscriber'

const apiNewsletterSubscriber = new APINewsletterSubscriber()


export default {
  name: 'NewsletterSubscriberModalComponent',
  mixins: [
    validationMixin
  ],
  data: function () {
    return {
      email: '',
      errorSaved: false,
      isNewsletterSubscriberModal: false
    }
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    routeName(){
      return this.$route.name
    },
  },
  validations: {
    email: {
      required,
      email
    },
  },
  created () {
    // Never open by itself during a prerender pass: the open modal would be
    // captured in the HTML snapshot and shipped to visitors as a popup nothing
    // can close (see webapp/scripts/prerender.js).
    const pathName = window.location.pathname
    if (!window.__PRERENDER__ && (pathName.includes('learn') || pathName.includes('news'))) {
      this.getNewsletterSubscribersSettings()
    }

    // Listen to an event to open the modal
    this.$eventHub.$on('openNewsletterSubscriberModal', () => {
      this.isNewsletterSubscriberModal = true
    })
  },
  beforeUnmount () {
    this.$eventHub.$off('openNewsletterSubscriberModal')
  },
  methods: {
    closeModal () {
      this.isNewsletterSubscriberModal = false
    },
    getNewsletterSubscribersSettings () {
      this.$store.commit('loadFromAPI')
      apiNewsletterSubscriber.getNewsletterSubscriberSettings()
      .then((result) => {
        const newsletterSubscriberExpiry = this.$store.state.newsletterSubscriberExpiry
        const now = new Date().getTime()
        if (
          result.data.open_newsletter_modal && 
          (!newsletterSubscriberExpiry || newsletterSubscriberExpiry < now) && 
          !this.isAuthenticated
        ) {
          this.isNewsletterSubscriberModal = true
          const randomDays = Math.floor(Math.random() * (5 - 2 + 1)) + 2
          this.$store.commit('setExpiry', now + randomDays * 24 * 60 * 60 * 1000)
        }
      })
      .catch((error) => {
        throw new Error('getNewsletterSubscribersSettings API Error : ' + String(error))
      })
      .finally(() => {
        this.$store.commit('endLoadingFromAPI')
      })
    },
    signUpNewsletter: function () {
      this.$store.commit('loadFromAPI')
      const data = {
        email: this.email.toLowerCase(),
      }
      this.errorSaved = false
      apiNewsletterSubscriber.createNewsletterSubscriber(data)
      .then(() => {
        this.$store.commit('closeNewsletterSubscriberModal')
        this.$bvToast.toast(this.$t('newsletter_subscriber_modal.toasts.registration_success_message'), {
          title: this.$t('newsletter_subscriber_modal.toasts.registration_success_title'),
          variant: 'success',
          solid: true
        })
        this.isNewsletterSubscriberModal = false
      })
      .catch((error) => {
        console.log(error)
        this.errorSaved = true
      })
      .finally(() => {
        this.$store.commit('endLoadingFromAPI')
        this.email = ''
      })
   },
  }
}
</script>

<style>
.newsletter-subscriber-modal-header {
  position: relative;
  width: 100%;
}

/* The close icon is positioned above the title so that it always receives the clicks */
.newsletter-subscriber-modal-header--close-icon {
  left: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.newsletter-subscriber-modal-header--title {
  padding-left: 35px;
  padding-right: 35px;
}

/* Needed on iOS to make the click on the backdrop close the modal */
.newsletter-subscriber-modal,
.newsletter-subscriber-modal .modal-dialog {
  cursor: pointer;
}

.newsletter-subscriber-modal .modal-content {
  cursor: auto;
}

.newsletter-subscriber-modal-body {
  padding: 10px 30px 30px 30px !important;
}

.newsletter-subscriber-modal-input {
  border-radius: 5px !important;
}

.newsletter-subscriber-modal-button {
  background-color: white;
  border: 1px solid black;
  border-radius: 5px;
  color: black;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 30px;
  padding-right: 30px;
  font-weight: bold;
  font-size: 1rem;
  width: 100%;
}
</style>